import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from "./Forgot.module.css";
import { Email } from "../../Svg";
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Forgot = () => {
    const [isSent, setIsSent] = useState(false);
    const navigate = useNavigate();

    // Formik form handling
    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid email address').required('Email is required')
        }),
        onSubmit: async (values) => {
            try {
                const response = await api.forgotPassword(values);
                if (response.data) {
                    setIsSent(true);
                    toast.success(response.data?.data?.message || 'Password reset link sent successfully');
                }
            } catch (err) {
                console.error("Error sending reset email:", err);
                toast.error(err?.response?.data?.message || 'something went wrong')
            }
        }
    });

    return (
        <div className={styles.logincontainer}>
            <div className={styles.loginimageSection}>
                <div className={styles.imageOverlayText}>
                    <h2>ELECTROWIZ</h2>
                    <p>The Complete Enterprise Platform for Electronic Component Distribution & Supply Chain Management.</p>
                </div>
            </div>
            <div className={styles.loginformSection}>
                <div className={styles.blob1}></div>
                <div className={styles.blob2}></div>
                <div className={styles.loginFormCard}>
                    {isSent ? (
                        <div className={styles.successContainer}>
                            <div className={styles.successIconContainer}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <div className={styles.loginwelcomeText}>
                                <div className={styles.loginlogo}>
                                    <span className={styles.logoIcon}>⚡</span>
                                    <span className={styles.logoText}>ELECTROWIZ</span>
                                </div>
                                <h1>Check Your Email</h1>
                                <p>We've sent a password reset link to <strong>{formik.values.email}</strong>. Please check your inbox and follow the instructions to reset your password.</p>
                            </div>
                            <button onClick={() => navigate('/')} className={styles.loginButton}>
                                Back to Login
                            </button>
                        </div>
                    ) : (
                        <>
                            <div className={styles.loginwelcomeText}>
                                <div className={styles.loginlogo}>
                                    <span className={styles.logoIcon}>⚡</span>
                                    <span className={styles.logoText}>ELECTROWIZ</span>
                                </div>
                                <h1>Forgot Password</h1>
                                <p>Enter the registered email id</p>
                            </div>
                            <form onSubmit={formik.handleSubmit} className={styles.loginformMain}>
                                {formik.touched.email && formik.errors.email && (
                                    <span className={styles.error}>{formik.errors.email}</span>
                                )}
                                <label>Email address</label>
                                <div className={styles.logininputContainer}>
                                    <Email />
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="john@example.com"
                                        className={styles.logininputField}
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                <button type="submit" className={styles.loginButton} disabled={formik.isSubmitting}>
                                    {formik.isSubmitting ? 'Please wait...' : 'Submit'}
                                </button>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Forgot;
